export default __webpack_public_path__ + "static/media/orangeJuice.326d2dd5.jpg";